import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Generic card matching the design mockup's pinned-card style (makeCard()'s cardStyle/
 * cardTopStyle/pathStyle/labelStyle). Home.html's existing .business-card divs are the natural
 * future migration target for this component, not touched in this pass.
 */
@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss'],
})
export class CardComponent {
    @Input() title?: string;
    @Input() icon?: string;
    @Input() clickable = false;

    @Output() readonly cardClick = new EventEmitter<void>();

    onClick(): void {
        if (this.clickable) {
            this.cardClick.emit();
        }
    }
}
